/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_Grams_UnknownInputs */

const en_fix_grams_unknown = /** @type {(inputs: Fix_Grams_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not known yet`)
};

const de_fix_grams_unknown = /** @type {(inputs: Fix_Grams_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch unbekannt`)
};

/**
* | output |
* | --- |
* | "Not known yet" |
*
* @param {Fix_Grams_UnknownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fix_grams_unknown = /** @type {((inputs?: Fix_Grams_UnknownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_Grams_UnknownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fix_grams_unknown(inputs)
	return en_fix_grams_unknown(inputs)
});